import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

const RadioGrup = ({ options, method, handleChange }) => {
  return (
    <FormControl sx={{ mt: 2, mb: 1 }}>
      <RadioGroup row value={method} onChange={handleChange}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioGrup;
